import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import { connect } from 'react-redux';
import { ChangeNavbar } from '../actions';

import {
  Container,
  Row,
  Col
} from 'reactstrap';

class GamesPrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.props.SetHeaderNavbar(false);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <section className="content no-header">
        <Container>
          <Row>
            <Col>
              <h1><Translate id="games_privacy_policy.title">Política de Privacidad</Translate></h1>

              <h2><Translate id="games_privacy_policy.subtitle">Esta página detalla la política de privacidad de nuestros juegos</Translate></h2>

              <h3><Translate id="games_privacy_policy.information.title">¿Qué información recolectamos?</Translate></h3>

              <p>
                <Translate id="games_privacy_policy.information.text">
                  Gone Mad Studios no recolecta ninguna información personal de nadie. Algunos de nuestros juegos recolecta información anónima de uso, tales como el tiempo invertido en los niveles, puntuación conseguida, etc. Estos datos anónimos son recogidos para mejorar nuestros juegos, así como la experiencia de juego.
                </Translate>
              </p>

              <h3><Translate id="games_privacy_policy.partners.title">¿Qué información recolecta los servicios de terceros incluidos en nuestros juegos?</Translate></h3>

              <p>
                <Translate id="games_privacy_policy.partners.text_1">
                  Algunos de nuestros juegos contienen anuncios, los cuales son proporcionados por empresas de confianza las cuales necesitan recolectar datos no identificatibos de la persona (como el modelo del dispositivo o su localización a nivel de pais o continente).
                </Translate>
              </p>

              <p>
                <Translate id="games_privacy_policy.partners.text_2">
                  También para funciones sociales del juego (tablas de puntuaciones, logros, compartir puntuaciones o conexión con redes sociales) los servicios de terceros pueden recolectar información necesaria para el servicio que ofrecen. Esta información recolectada son datos no identificativos de la persona, excepto en casos donde explícitamente se registre (o inicie sesión) con datos personales, como por ejemplo su dirección de e-mail. Nuestros juegos no recolectarán sus datos personales sin su consentimiento.
                </Translate>
              </p>

              <p>
                <Translate id="games_privacy_policy.partners.text_3">
                  Compruebe la siguiente lista si desea obtener más información sobra la Política de Privacidad de los servicios de terceros incluidos en nuestros juegos.
                </Translate>
              </p>

              <ul>
                <li><Translate id="games_privacy_policy.partners.list.item_1.title">Analítica:</Translate> <a href="https://unity.com/solutions/mobile-business/operate-your-live-game"><Translate id="games_privacy_policy.partners.list.item_1.text">Unity Analytics</Translate></a> (<a href="https://unity3d.com/legal/privacy-policy"><Translate id="games_privacy_policy.partners.list.link">política de privacidad</Translate></a>)</li>
                <li><Translate id="games_privacy_policy.partners.list.item_2.title">Anuncios:</Translate> <a href="https://unity.com/solutions/unity-ads"><Translate id="games_privacy_policy.partners.list.item_2.text">Unity Ads</Translate></a> (<a href="https://unity3d.com/legal/privacy-policy"><Translate id="games_privacy_policy.partners.list.link">política de privacidad</Translate></a>)</li>
                <li><Translate id="games_privacy_policy.partners.list.item_3.title">Servicios del Juego:</Translate> <a href="https://developers.google.com/games/services/"><Translate id="games_privacy_policy.partners.list.item_3.text">Google Play Games</Translate></a> (<a href="https://policies.google.com/privacy?hl=en"><Translate id="games_privacy_policy.partners.list.link">política de privacidad</Translate></a>)</li>
              </ul>

              <p>
                <Translate id="games_privacy_policy.partners.text_4">
                  Aparte de la lista anterior no se proporciona ningún dato a otras terceras partes.
                </Translate>
              </p>

              <h3><Translate id="games_privacy_policy.consent.title">Consentimiento</Translate></h3>

              <p>
                <Translate id="games_privacy_policy.consent.text">
                  Usando nuestros juegos de móvil, acepta el consentimiento de los términos de esta Política de Privacidad.
                </Translate>
              </p>

              <h3><Translate id="games_privacy_policy.changes.title">Cambios en nuestra Política de Privacidad</Translate></h3>

              <p>
                <Translate id="games_privacy_policy.changes.text">
                  Gone Mad Studios se guarda el derecho a modificar esta Política de Privacidad a su discreción. Si se realiza cualquier cambio en este documento, se actualizará la fecha de modificación indicada más abajo.
                </Translate>
              </p>

              <p>
                <Translate id="games_privacy_policy.changes.last">
                  Esta Política de Privacidad fue modificada por última vez el 14 de Marzo de 2019.
                </Translate>
              </p>

              <h3><Translate id="games_privacy_policy.contact.title">Contáctenos</Translate></h3>

              <p>
                <Translate id="games_privacy_policy.contact.text">
                  Si tiene alguna pregunta sobre esta política de privacidad, puede ponerse en contacto con nosotros enviándonos un e-mail a:
                </Translate>
              </p>

              <a href="mailto:gonemadstudios@gmail.com" >gonemadstudios@gmail.com</a>

            </Col>
          </Row>
        </Container>
      </section>
      );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SetHeaderNavbar: (haveHeader) => {dispatch(ChangeNavbar(haveHeader))}
  }
}

function mapStateToProps(state) {
  return { }
}

export default connect (
  mapStateToProps,
  mapDispatchToProps
)(GamesPrivacyPolicy);
